import { queryInsertionPoints, removeInsertionPointIfStale } from '../../../helpers/insertionPoint';
import { ContentEditableEditorPlugin } from './contentEditableEditorPlugin';

export const createInsertionPointPlugin = (): ContentEditableEditorPlugin => ({
  processText: element => {
    // Allow us to have insertion points at a fake cursor before the first focus.
    if (element.ownerDocument && !element.contains(element.ownerDocument.activeElement)) {
      return;
    }

    // TODO: Benchmark/profile this.
    const nodes = queryInsertionPoints(element);
    if (!nodes.length) {
      return;
    }

    nodes.forEach(node => {
      removeInsertionPointIfStale(node);
    });
  },
});
